import { Module } from 'mana-syringe';
import { WebGLContextService } from './WebGLContextService';
var containerModule = Module(function (register) {
  /**
   * implements ContextService
   */
  register(WebGLContextService);
});

var ContextRegisterPlugin =
/** @class */
function () {
  function ContextRegisterPlugin() {}

  ContextRegisterPlugin.prototype.init = function (container) {
    container.load(containerModule, true);
  };

  ContextRegisterPlugin.prototype.destroy = function (container) {
    container.unload(containerModule);
  };

  return ContextRegisterPlugin;
}();

export { ContextRegisterPlugin };